<!-- TODO: text should be coming from workflow json or dictionary flvor.json, not hardcoded -->
<div class="bl-margin-bottom--16" [ngClass]="{ 'bl-display--none': !showEligibilityQuestions }">
  <fieldset>
    <legend [ngClass]="{ 'bl-validation-error': (pageSubmitted$ | async) && !questionnaireSelection }">
      <div class="bl-font-size--14 bl-font-weight--800 bl-margin-bottom--4 bl-required">{{ getQuestionnaireLabelText() }}</div>
    </legend>
    <div
      *ngFor="let question of dynamicEligibilityQuestions; index as questionIndex"
      class="bl-margin-bottom--8 bl-margin-top--4"
      [ngClass]="{ 'bl-validation-error': (pageSubmitted$ | async) && !questionnaireSelection }"
    >
      <div class="bl-check-wrap">
        <input
          type="radio"
          name="dynamicEligibilityGroup"
          [id]="'question-' + question.id"
          [attr.data-automation-id]="'question-' + questionIndex"
          [value]="question.id"
          [(ngModel)]="questionnaireSelection"
          (change)="selectionChanged()"
          required
        />
        <label class="bl-label" for="question-{{ question.id }}">{{ question.questionText }}</label>
      </div>
      <div *ngIf="question.id === questionnaireSelection">
        <div *ngFor="let questionField of question.questionFields; index as fieldIndex">
          <div *ngIf="hasQuestionFieldDropdown(questionField)">
            <div class="bl-margin-bottom--16 bl-margin-left--8 bl-margin-left-sm--24">
              <div
                [ngClass]="{
                  'bl-validation-error': questionField.isRequired && !questionField.selectedLookupItemID && (pageSubmitted$ | async)
                }"
              >
                <label
                  class="bl-label bl-font-weight--800 bl-font-size--14"
                  [ngClass]="{ 'bl-required': questionField.isRequired }"
                  for="oao-eligibility-questionField--{{ questionField.option.id }}"
                >
                  {{ questionField.label }}
                </label>
                <div class="bl-select-wrap">
                  <select
                    class="bl-select bl-input"
                    id="oao-eligibility-questionField--{{ questionField.option.id }}"
                    [(ngModel)]="questionField.selectedLookupItemID"
                    [attr.data-automation-id]="'questionField-' + fieldIndex"
                    (change)="questionAnswerChanged(question, questionIndex, fieldIndex)"
                  >
                    <option [value]="undefined" disabled selected>{{ 'dynamicEligility/select' | dictionary }}</option>
                    <option *ngFor="let optionItem of questionField.option.items" [value]="optionItem.lookupItemID">
                      {{ optionItem.label }}
                    </option>
                  </select>
                </div>
                <span
                  *ngIf="!questionField.selectedLookupItemID && questionField.isRequired && (pageSubmitted$ | async)"
                  class="bl-error-msg bl-margin-right--16"
                  aria-live="assertive"
                  aria-label="alert"
                  >{{ 'dynamicEligility/required' | dictionary }}</span
                >
              </div>
            </div>
          </div>
          <div *ngIf="hasQuestionFieldRadioList(questionField)">
            <div class="bl-margin-bottom--16 bl-margin-left--8 bl-margin-left-sm--24">
              <div [ngClass]="{ 'bl-validation-error': questionField.isRequired && (pageSubmitted$ | async) }">
                <label
                  class="bl-label bl-font-weight--800 bl-font-size--14"
                  [ngClass]="{ 'bl-required': questionField.isRequired }"
                  for="oao-eligibility-questionField"
                >
                  {{ questionField.label }}
                </label>
                <div class="bl-check-wrap">
                  <div *ngFor="let item of questionField.option.items; index as i">
                    <input
                      type="radio"
                      (change)="questionAnswerChanged(question, questionIndex, fieldIndex)"
                      [attr.data-automation-id]="'radio-' + fieldIndex"
                      id="radio-{{ questionIndex }}-{{ i }}"
                      [(ngModel)]="questionField.value"
                      [value]="item.value"
                      name="radio-{{ questionIndex }}-{{ i }}"
                    />
                    <label class="bl-label" for="radio-{{ questionIndex }}-{{ i }}">{{ item.label }}</label>
                  </div>
                </div>
                <span
                  *ngIf="!questionField.value && questionField.isRequired && (pageSubmitted$ | async)"
                  class="bl-error-msg bl-margin-right--16"
                  aria-live="assertive"
                  aria-label="alert"
                  >{{ 'dynamicEligility/required' | dictionary }}</span
                >
              </div>
            </div>
          </div>
          <div *ngIf="hasQuestionFieldTextBox(questionField)">
            <div class="bl-margin-bottom--16 bl-margin-left--8 bl-margin-left-sm--24">
              <div [ngClass]="{ 'bl-validation-error': questionField.isRequired && !questionField.value && (pageSubmitted$ | async) }">
                <label
                  class="bl-label bl-font-weight--800 bl-font-size--14"
                  [ngClass]="{ 'bl-required': questionField.isRequired }"
                  for="oao-eligibility-questionField-input-{{ questionIndex }}-{{ fieldIndex }}"
                >
                  {{ questionField.label }}
                </label>
                <input
                  type="text"
                  class="bl-input"
                  id="oao-eligibility-questionField-input-{{ questionIndex }}-{{ fieldIndex }}"
                  [attr.data-automation-id]="'questionField-input-' + fieldIndex"
                  [maxlength]="questionField.maxLength"
                  placeholder=""
                  [(ngModel)]="questionField.value"
                  (ngModelChange)="questionAnswerChanged(question, questionIndex, fieldIndex)"
                />
              </div>
              <span
                *ngIf="!questionField.value && questionField.isRequired && (pageSubmitted$ | async)"
                class="bl-error-msg bl-margin-right--16"
                aria-live="assertive"
                aria-label="alert"
                >{{ 'dynamicEligility/required' | dictionary }}</span
              >
            </div>
          </div>
          <div *ngIf="hasQuestionFieldNumber(questionField)">
            <div class="bl-margin-bottom--16 bl-margin-left--8 bl-margin-left-sm--24">
              <div [ngClass]="{ 'bl-validation-error': questionField.isRequired && !questionField.value && (pageSubmitted$ | async) }">
                <label
                  class="bl-label bl-font-weight--800 bl-font-size--14"
                  [ngClass]="{ 'bl-required': questionField.isRequired }"
                  for="oao-eligibility-questionField-input-number-{{ questionIndex }}-{{ fieldIndex }}"
                >
                  {{ questionField.label }}
                </label>
                <input
                  type="number"
                  class="bl-input"
                  id="oao-eligibility-questionField-input-number-{{ questionIndex }}-{{ fieldIndex }}"
                  [attr.data-automation-id]="'questionField-input-number-' + fieldIndex"
                  [maxlength]="questionField.maxLength"
                  placeholder=""
                  [(ngModel)]="questionField.value"
                  (ngModelChange)="questionAnswerChanged(question, questionIndex, fieldIndex)"
                />
              </div>
              <span
                *ngIf="!questionField.value && questionField.isRequired && (pageSubmitted$ | async)"
                class="bl-error-msg bl-margin-right--16"
                aria-live="assertive"
                aria-label="alert"
                >{{ 'dynamicEligility/required' | dictionary }}</span
              >
            </div>
          </div>
          <div *ngIf="hasQuestionFieldDate(questionField)">
            <div class="bl-margin-bottom--16 bl-margin-left--8 bl-margin-left-sm--24">
              <div [ngClass]="{ 'bl-validation-error': questionField.isRequired && (pageSubmitted$ | async) }">
                <label
                  class="bl-label bl-font-weight--800 bl-font-size--14"
                  [ngClass]="{ 'bl-required': questionField.isRequired }"
                  for="oao-eligibility-questionField-date-input-{{ questionIndex }}-{{ fieldIndex }}"
                >
                  {{ questionField.label }}
                </label>
                <input
                  type="text"
                  class="bl-input"
                  id="oao-eligibility-questionField-date-input-{{ questionIndex }}-{{ fieldIndex }}"
                  [attr.data-automation-id]="'questionField-date-input-' + fieldIndex"
                  placeholder="MM / DD / YYYY"
                  (blur)="processMask($event)"
                  (focus)="processMask($event)"
                  (cut)="processMask($event)"
                  (paste)="processMask($event)"
                  (input)="processMask($event)"
                  (keyup)="processMask($event)"
                  (mouseup)="processMask($event)"
                  [(ngModel)]="questionField.value"
                  (ngModelChange)="questionAnswerForDateField(question, questionIndex, fieldIndex)"
                />
              </div>
              <span
                *ngIf="!questionField.value && questionField.isRequired && (pageSubmitted$ | async)"
                class="bl-error-msg bl-margin-right--16"
                aria-live="assertive"
                aria-label="alert"
                >{{ 'dynamicEligility/required' | dictionary }}</span
              >
            </div>
          </div>

          <div *ngIf="hasQuestionFieldRadio(questionField)">
            <div class="bl-margin-bottom--16 bl-margin-left--8 bl-margin-left-sm--24">
              <div [ngClass]="{ 'bl-validation-error': questionField.isRequired && (pageSubmitted$ | async) }">
                <label
                  class="bl-label bl-font-weight--800 bl-font-size--14"
                  [ngClass]="{ 'bl-required': questionField.isRequired }"
                  for="oao-eligibility-questionField-input-number-{{ questionIndex }}-{{ fieldIndex }}"
                >
                  {{ questionField.label }}
                </label>
                <div class="bl-check-wrap bl-margin-top--4 bl-margin-bottom--8">
                  <input
                    type="radio"
                    name="oao-eligibility-questionField-radio-input-true-{{ questionIndex }}-{{ fieldIndex }}"
                    id="oao-eligibility-questionField-radio-input-true-{{ questionIndex }}-{{ fieldIndex }}"
                    [attr.data-automation-id]="'questionField-input-true' + fieldIndex"
                    [value]="true"
                    [(ngModel)]="questionField.value"
                    (change)="questionAnswerChanged(question, questionIndex, fieldIndex)"
                  />
                  <label class="bl-label" for="oao-eligibility-questionField-radio-input-true-{{ questionIndex }}-{{ fieldIndex }}"
                    >Yes</label
                  >
                </div>
                <div class="bl-check-wrap bl-margin-top--4 bl-margin-bottom--8">
                  <input
                    type="radio"
                    name="oao-eligibility-questionField-radio-input-false-{{ questionIndex }}-{{ fieldIndex }}"
                    id="oao-eligibility-questionField-radio-input-false-{{ questionIndex }}-{{ fieldIndex }}"
                    [attr.data-automation-id]="'questionField-false-' + fieldIndex"
                    [value]="false"
                    [(ngModel)]="questionField.value"
                    (change)="questionAnswerChanged(question, questionIndex, fieldIndex)"
                  />
                  <label class="bl-label" for="oao-eligibility-questionField-radio-input-false-{{ questionIndex }}-{{ fieldIndex }}"
                    >No</label
                  >
                </div>
                <span
                  *ngIf="questionField.value == undefined && questionField.isRequired && (pageSubmitted$ | async)"
                  class="bl-error-msg bl-margin-right--16"
                  aria-live="assertive"
                  aria-label="alert"
                  >{{ 'dynamicEligility/required' | dictionary }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span *ngIf="!questionnaireSelection && (pageSubmitted$ | async)" class="bl-error-msg bl-margin-right--16">{{
      'dynamicEligility/required' | dictionary
    }}</span>
  </fieldset>
</div>
